@if (itinerary$ | withLoading | async; as itineraryLoading) {
    <div>
        @if (itineraryLoading.loading || (loading | async)) {
            <div class="flex min-h-screen flex-col items-center justify-center">
                <app-loader color="#EE5769"></app-loader>
            </div>
        }
        @if (
            !itineraryLoading.loading &&
            !(loading | async) &&
            !itineraryLoading.value
        ) {
            <app-builder-page-fallback [content]="builderContent()">
            </app-builder-page-fallback>
        }
        @if (
            !itineraryLoading.loading &&
            !(loading | async) &&
            itineraryLoading.value
        ) {
            @if (itinerary$ | async; as itinerary) {
                <article>
                    <div
                        class="aspect-h-1 aspect-w-1 z-10 md:aspect-w-2 2xl:aspect-w-3">
                        <app-lazy-picture
                            [lazy]="false"
                            [configurations]="
                                featuredImageConfiguration | async
                            ">
                        </app-lazy-picture>
                    </div>
                    <div
                        class="relative z-10 mx-auto max-w-screen-xl pb-4 md:-mt-64 md:pl-[5%]">
                        <div
                            class="space-y-4 bg-secondary-blue/95 p-4 py-8 text-white shadow-lg md:max-w-xl md:rounded-fa md:p-8">
                            <div>
                                <h1 class="pb-0">{{ itinerary.title }}</h1>
                                <p>
                                    <app-trips-itinerary-breadcrumbs
                                        [itinerary]="
                                            itinerary
                                        "></app-trips-itinerary-breadcrumbs>
                                </p>
                            </div>
                            <p>
                                <fa-icon [icon]="faClock"></fa-icon>
                                {{ itinerary?.daysCollection.total }} days
                            </p>
                            <div class="w-4/5">
                                <app-rich-text-document
                                    [document]="
                                        itinerary?.description?.json
                                    "></app-rich-text-document>
                            </div>
                        </div>
                    </div>

                    <div class="trips-itinerary-navigation-container">
                        <app-trips-itinerary-navigation
                            [selfBookingDeparturesContainer]="
                                selfBookingDeparturesContainer
                            "
                            [itinerary]="
                                itinerary
                            "></app-trips-itinerary-navigation>
                    </div>

                    <div class="mx-auto mb-28 max-w-screen-xl space-y-32 pt-16">
                        <section
                            class="scroll-mt-96 space-y-16 md:scroll-mt-32 md:px-8 xl:p-0"
                            appTripsItinerarySection
                            title="Details">
                            <h2 class="pl-4 tracking-wide">
                                Detailed Itinerary
                            </h2>
                            <div class="max-w-screen-md">
                                <app-lazy-asset
                                    [configuration]="
                                        mapConfiguration | async
                                    "></app-lazy-asset>
                            </div>
                            <div class="grid grid-cols-1 gap-16">
                                @for (
                                    day of itinerary?.daysCollection.items;
                                    track day.sys.id;
                                    let index = $index
                                ) {
                                    <div class="block">
                                        <app-trips-itinerary-day
                                            [day]="day"
                                            [dayNumber]="index + 1">
                                        </app-trips-itinerary-day>
                                    </div>
                                }
                            </div>
                        </section>
                        <div class="mt-4">
                            <app-trips-inclusions-exclusions-section
                                [itinerary]="itinerary">
                            </app-trips-inclusions-exclusions-section>
                        </div>

                        @if (
                            itinerary?.accommodationCollection?.items?.length
                        ) {
                            <section
                                class="scroll-mt-96 px-4 md:scroll-mt-32 md:px-8 xl:p-0"
                                appTripsItinerarySection
                                title="Accommodation">
                                <app-trips-itinerary-accommodation
                                    [accommodations]="
                                        itinerary.accommodationCollection.items
                                    "></app-trips-itinerary-accommodation>
                            </section>
                        }
                        @if ((itinerary$ | async).trip?.showGroupDepartures) {
                            <div
                                class="mx-auto max-w-screen-lg scroll-m-56"
                                #selfBookingDeparturesContainer>
                                <app-trips-trip-self-booking
                                    [itineraryPageId]="
                                        (itinerary$ | async)
                                            .linkedVirtualOfficeItinerary
                                    "
                                    [trip]="
                                        (itinerary$ | async).trip
                                    "></app-trips-trip-self-booking>
                            </div>
                        }
                        @if (
                            itinerary?.linkedFrom?.reviewCollection?.items
                                ?.length
                        ) {
                            <section
                                class="scroll-mt-96 px-4 md:scroll-mt-32 md:px-8 xl:p-0"
                                appTripsItinerarySection
                                title="Reviews">
                                <app-home-reviews class="block">
                                </app-home-reviews>
                            </section>
                        }

                        <div class="mt-2">
                            <app-home-why-followalice
                                [reasons]="why"
                                [whyDesc]="
                                    whyDesc | async
                                "></app-home-why-followalice>
                        </div>

                        @if (itinerary?.galleryCollection?.total) {
                            <section
                                class="scroll-mt-96 md:scroll-mt-32 md:px-8 xl:p-0">
                                <h2 class="pb-16 pl-4 tracking-wide">
                                    Gallery
                                </h2>
                                <div>
                                    <app-trips-itinerary-gallery
                                        [assets]="
                                            itinerary?.galleryCollection?.items
                                        "></app-trips-itinerary-gallery>
                                </div>
                            </section>
                        }
                    </div>
                    @if (itinerary?.faqsCollection?.items?.length) {
                        <section>
                            <app-home-faq-newsletter-section
                                [faqBackgroundImage]="
                                    itinerary.faqBackgroundImage?.image
                                "
                                [faqs]="
                                    itinerary?.faqsCollection?.items
                                "></app-home-faq-newsletter-section>
                        </section>
                    }
                    <app-json-ld [json]="seoProduct | async"></app-json-ld>
                </article>
            }
        }
    </div>
}
